<template>
  <div class="grid grid-cols-12 py-12">
    <div class="col-span-9 flex flex-col gap-4 mt-4">
      <h1 class="text-2xl lg:text-4xl font-bold leading-tight">
        <span class="line-clamp-1">
          {{
            userStore.isFptMarket
              ? "Tổng hợp question bank"
              : LL.challenging_every_interview_question()
          }}
        </span>
        <span class="hidden">{{ ` ${language}` }}</span>
        <span class="text-secondary-600">{{
          userStore.isFptMarket ? "cho sinh viên FPT" : ` ${LL.for_developers()}`
        }}</span>
      </h1>
      <p>
        <span
          class="bg-secondary-800 text-white px-2 py-1 rounded-lg font-xl font-bold"
          >{{ countQuestions }}</span
        >
        {{ userStore.isFptMarket ? "câu hỏi" : LL.interview_description() }}
      </p>
      <div class="flex gap-2 flex-col md:flex-row">
        <UButton
          v-if="userStore.isVietnamMarket"
          icon="i-heroicons-command-line"
          size="md"
          color="secondary"
          variant="soft"
          label="Button"
          class="mt-2 w-max"
          :trailing="false"
          preload="false"
          to="/phong-van-pro/full-stack-web-and-mobile-global/java-global"
          target="_blank"
        >
          Câu hỏi Global
        </UButton>
        <UButton
          v-if="isCanDownload"
          icon="i-heroicons-arrow-down"
          size="md"
          color="secondary"
          variant="soft"
          label="Button"
          class="mt-2 w-max"
          :trailing="false"
          preload="false"
          to="https://drive.google.com/drive/u/1/folders/1oxhDqRAQIH5SMxZTJsEWdabNXRMftfHL"
          target="_blank"
        >
          {{ LL.download_ebook() }}
        </UButton>
        <UTooltip v-else :text="LL.need_upgrade_rank_ebook()">
          <UButton
            icon="i-heroicons-arrow-down"
            size="md"
            color="neutral"
            variant="soft"
            label="Button"
            class="mt-2"
            :trailing="false"
            @click="handleDownloadEbook"
          >
            {{ LL.download_ebook() }}
          </UButton>
        </UTooltip>
      </div>
    </div>
    <div class="col-span-3">
      <img
        src="@/assets/images/question.svg"
        alt="Câu hỏi phỏng vấn lập trình"
        width="205"
        height="210"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useUserStore } from "../../store/user";
import { ERole } from "~/constants/enum";
import { typesafeI18n } from "~/locales/i18n-vue";

const userStore = useUserStore();
const router = useRouter();

type Props = {
  language: string;
  countQuestions: number | null;
};

withDefaults(defineProps<Props>(), {
  language: "",
  countQuestions: 0,
});

const { LL } = typesafeI18n();

const isCanDownload = computed(() => {
  const allowedRoles = [ERole.Gold, ERole.Diamond, ERole.Admin, ERole.SuperAdmin];
  return allowedRoles.some((role) => userStore.roles.includes(role));
});

const handleDownloadEbook = () => {
  userStore.checkIsLogged(LL.value.you_need_to_login_to_action(), () => {
    router.push("/nang-cap-tai-khoan");
  });
};
</script>
